import { useRegion } from 'common/hooks/region';
import { isPageSupported, Page } from 'constants/pages';
import * as React from 'react';
import { generatePath, Link } from 'react-router-dom';

interface Props {
  page: Page;
  onMenuOpen: () => void;
}

export const MenuDropdownItem: React.FC<Props> = (props) => {
  const { page, onMenuOpen } = props;
  const region = useRegion();
  const to = generatePath(page.path, { region: region.route });
  const disabled = !isPageSupported(page, region);

  return (
    <li className={`${disabled ? 'pointer-events-none' : ''} pl-4`} onClick={onMenuOpen}>
      <Link
        to={to}
        className={`flex items-center font-semibold ${disabled ? 'text-gray-400' : 'text-blue-300'}
`}
      >
        <h2 className="py-1 px-4 rounded-md hover:bg-darkblue-900">{page.title}</h2>
        {disabled && <h4>(only in LA/LB)</h4>}
      </Link>
    </li>
  );
};
MenuDropdownItem.displayName = 'MobileNav.MenuDropdown.Item';
